import React from 'react'
import { InputNumber } from 'primereact/inputnumber'

export default function LtsCurrency(props) {
  const { onChange, onBlur, inputProps: inputPropsProp, ...restProps } = props

  const parseNumericValue = (raw) => {
    if (raw == null) return null
    if (typeof raw === 'number' && !Number.isNaN(raw)) return raw
    const str = String(raw).trim()
    if (!str) return null

    const compact = str.replace(/\s/g, '').replace(/R\$/gi, '').replace(/[^0-9,.-]/g, '')
    if (!compact) return null

    const negative = compact.startsWith('-')
    const lastComma = compact.lastIndexOf(',')
    const lastDot = compact.lastIndexOf('.')
    const decimalIndex = Math.max(lastComma, lastDot)
    const hasComma = lastComma >= 0
    const hasDot = lastDot >= 0
    const maxFractionDigits = Number.isInteger(restProps.maxFractionDigits)
      ? restProps.maxFractionDigits
      : Number.isInteger(props.maxFracionDigits)
        ? props.maxFracionDigits
        : null

    let integerPart = compact
    let fractionPart = ''
    if (decimalIndex > 0 && decimalIndex < compact.length - 1) {
      const candidateInteger = compact.substring(0, decimalIndex)
      const candidateFraction = compact.substring(decimalIndex + 1)
      const fractionDigitsOnly = candidateFraction.replace(/[^0-9]/g, '')

      const singleSeparatorType = (hasComma && !hasDot) || (!hasComma && hasDot)
      const shouldTreatAsThousands =
        singleSeparatorType &&
        fractionDigitsOnly.length === 3 &&
        (maxFractionDigits === null || maxFractionDigits === 0)

      if (!shouldTreatAsThousands) {
        integerPart = candidateInteger
        fractionPart = candidateFraction
      }
    }

    const integerDigits = integerPart.replace(/[^0-9]/g, '')
    const fractionDigits = fractionPart.replace(/[^0-9]/g, '')
    const normalized = `${negative ? '-' : ''}${integerDigits}${fractionDigits ? `.${fractionDigits}` : ''}`

    if (!normalized || normalized === '-') return null
    const n = Number(normalized)
    return Number.isNaN(n) ? null : n
  }

  const resolveName = () => {
    return props.name || 'valor'
  }

  const resolveInputId = () => {
    return props.inputId || resolveName()
  }

  const resolveLabel = () => {
    if (props.label) {
      return <label htmlFor={resolveInputId()}>{props.label}</label>
    }
    return null
  }

  const resolveMode = () => {
    if (props.mode) {
      return props.mode
    }
    return 'currency'
  }

  return (
    <React.Fragment>
      <span className="p-float-label">
        <InputNumber
          {...restProps}
          inputId={resolveInputId()}
          mode={resolveMode()}
          currency="BRL"
          minFractionDigits={props?.minFractionDigits ?? 2}
          value={props.value}
          allowEmpty={props.allowEmpty ?? true}
          onValueChange={(e) => onChange?.(e.value)}
          onChange={(e) => onChange?.(e.value)}
          onBlur={(e) => {
            const parsed = parseNumericValue(e?.target?.value)
            const current = typeof props.value === 'number' && !Number.isNaN(props.value) ? props.value : null
            if (parsed !== current) onChange?.(parsed)
            onBlur?.(e)
          }}
          name={resolveName()}
          inputProps={{
            ...(inputPropsProp || {}),
            autoComplete: (inputPropsProp && inputPropsProp.autoComplete) || 'off',
          }}
        />
        {resolveLabel()}
      </span>
    </React.Fragment>
  )
}
